import { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import NavigationStore from '../../redux/navigation';
import { IAsync, Project } from '../../types';
import utils from '../../utils';
import Redirect from '../generic/Redirect';
import type { NavigationState } from '../../redux/navigation';

interface IProjectEmptyProps {
  name?: string;
  params?: any;
  project?: IAsync<Project>;
}

type DispatchProps = {
  setNavState: (newState: Partial<NavigationState>) => void;
};

class ProjectEmpty extends Component<IProjectEmptyProps & DispatchProps, any> {
  componentDidMount() {
    if (!this.props.project.data || !this.props.project.data.default_branch || !this.props.project.data.locator) {
      this.props.setNavState({
        expand: false,
        subnav: null,
        navProps: {},
      });
    }
  }

  render() {
    if (
      !this.props.params.reference &&
      this.props.project.data &&
      this.props.project.data.default_branch &&
      this.props.project.data.locator
    ) {
      return (
        <Redirect
          replace
          to={
            '/projects/' +
            utils.nuc(this.props.project.data.locator) +
            '/refs/branch/' +
            utils.nuc(this.props.project.data.default_branch)
          }
        />
      );
    } else {
      return (
        <div className="text-center">
          <h1>404 - Project not found</h1>
          <hr />
          <Link to="/">
            <Button bsStyle="primary">Go Back Home</Button>
          </Link>
        </div>
      );
    }
  }
}

const mapDispatchToProps = {
  setNavState: NavigationStore.actions.setNavState,
};

export default connect(null, mapDispatchToProps)(ProjectEmpty);
